/**
 * Assembly section layout. Queue is list-only; work order detail is a child route.
 */

import { Outlet } from "react-router-dom";

export function AssemblyLayout() {
  return <Outlet />;
}
